<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Client</div>
                <div class="text-right mb-3">
                    <button type="button" class="btn" @click="showModal">Add Client</button>
                </div>
                <b-modal title="Add Client" ref="modal-add-client">
                    <form action="">
                        <div class="form-group">
                            <label for="">Code Exchanger</label>
                            <select name="" id="" v-model="formAddClient.code_exc">
                                <option value="" disabled selected>Choose Code Exchanger</option>
                                <option v-for="(code, i) in dataExchanger" :key="i" :value="code.codeexc">{{ code.nameexc }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="">PIC Name</label>
                            <input type="text" class="form-input" placeholder="input pic name" v-model="formAddClient.fullname" />
                        </div>
                        <div class="form-group">
                            <label for="">PIC Phonenumber</label>
                            <input type="text" class="form-input" placeholder="input pic phonumber" v-model="formAddClient.phonenumber" />
                        </div>
                        <div class="form-group">
                            <label for="">Company Name</label>
                            <input type="text" class="form-input" placeholder="input company name" v-model="formAddClient.company_name" />
                        </div>
                        <div class="form-group">
                            <label for="">Company Email</label>
                            <input type="text" class="form-input" placeholder="input company email" v-model="formAddClient.email" />
                        </div>
                        <div class="form-group">
                            <label for="">Password</label>
                            <input type="password" class="form-input" placeholder="input password" v-model="formAddClient.password" />
                        </div>
                    </form>
                    <template #modal-footer>
                        <div class="wrap-button">
                            <button class="btn mr-3" type="button">Cancel</button>
                            <button class="btn btn-primer" type="button" @click="addClient">
                                <b-spinner small v-if="isloadingAddClient"></b-spinner>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </template>
                </b-modal>
                <div class="content">
                    <table>
                        <thead>
                            <tr id="top">
                                <th scope="col" style="width: 70px">No</th>
                                <th scope="col">Company Name</th>
                                <th scope="col">Register Date</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(vendor, i) in vendorDatas" :key="vendor._id">
                                <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                                <td>{{ vendor.company_name }}</td>
                                <td>{{ vendor.updated_at | formatTime }}</td>
                                <td>{{ vendor.status }}</td>
                                <td>
                                    <!-- <button type="button" class="btn btn-outline-info btn-sm" @click="openmodal(vendor._id, 'detail-visitor')">Detail</button> -->
                                    <span v-if="vendor.status == 'request'">
                                        <button type="button" class="btn btn-outline-success btn-sm mx-2" @click="openmodal(vendor._id, 'approve')">Accept</button>
                                        <button type="button" class="btn btn-outline-danger btn-sm" @click="openmodal(vendor._id, 'reject')">Reject</button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <b-modal ref="approve" :title="'Accept Client ' + clientName" hide-footer>
                        <div v-if="detailVendor">
                            <form action="">
                                <div class="form-group">
                                    <label for="">Code Exchanger</label>
                                    <select name="" id="" v-model="form.code_exc">
                                        <option value="" disabled selected>Choose Code Exchanger</option>
                                        <option v-for="(code, i) in dataExchanger" :key="i" :value="code.codeexc">{{ code.nameexc }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="">Description</label>
                                    <textarea name="" id="" placeholder="input description" v-model="form.description"> </textarea>
                                </div>
                            </form>
                        </div>
                        <div class="text-right mt-4">
                            <button type="button" class="btn btn-scondary mr-2" @click="hideModal('approve')">Cancel</button>
                            <button type="submit" class="btn btn-primer" @click="handleOk('approve')">
                                <b-spinner small v-if="isLoadingStatus"></b-spinner>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </b-modal>
                    <b-modal ref="reject" :title="'Reject Vendor ' + clientName" hide-footer>
                        <div class="form-group">
                            <label for="">Description</label>
                            <textarea name="" id="" placeholder="input description" v-model="form.description"> </textarea>
                        </div>

                        <div class="text-right mt-4">
                            <button type="button" class="btn btn-scondary mr-2" @click="hideModal('reject')">Cancel</button>
                            <button type="submit" class="btn btn-primer" @click="handleOk('reject')">
                                <b-spinner small v-if="isLoadingStatus"></b-spinner>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </b-modal>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="lengthData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="lengthData > 10"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import sha256 from "sha256";
export default {
    components: {},
    data() {
        return {
            dataTransaction: [],
            pageOfItems: [],
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            trade_id: [],
            offset: 0,
            vendorDatas: [],
            detailVendor: null,
            titlePreview: "",
            imgPreview: "",
            loadingImgPreview: false,
            isLoadingStatus: false,
            isloadingAddClient: false,
            clientName: "",
            dataExchanger: [],
            form: {
                code_exc: "",
                description: "",
                status: "",
            },
            formAddClient: {
                email: "",
                phonenumber: "",
                password: "",
                fullname: "",
                company_name: "",
                code_exc: "",
            },
        };
    },
    mounted() {
        this.getData(this.currentPage);
        axios.get("/v2/clearing/admin/abx/exchanger/list").then((res) => {
            this.dataExchanger = res.data.data;
        });
    },
    methods: {
        showModal() {
            this.$refs["modal-add-client"].show();
        },
        addClient() {
            this.isloadingAddClient = true;
            this.formAddClient.password = sha256(this.formAddClient.password);
            axios
                .post("/v2/clearing/admin/abx/vendor/add", this.formAddClient)
                .then((res) => {
                    if (!res.data.iserror) {
                        this.isloadingAddClient = false;
                        this.$toast.success("Add Client Success");
                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                });
        },
        async openViewImg(urlImg, title) {
            this.loadingImgPreview = true;
            let image = await axios.get("/v2/vms/external/" + this.detailVendor.user_id + urlImg, { responseType: "blob" });
            this.titlePreview = title;
            this.imgPreview = URL.createObjectURL(new Blob([image.data], { type: image.data.type }));
            this.loadingImgPreview = false;
        },
        openmodal(id, modal) {
            this.detailVendor = null;
            this.detailVendor = this.vendorDatas.find((data) => data._id == id);
            this.clientName = this.detailVendor.company_name;
            this.imgPreview = "";
            this.$refs[modal].show();
        },

        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        handleOk(status) {
            this.isLoadingStatus = true;
            this.form.status = status;
            let data;
            if (status == "approve") {
                data = this.form;
            } else {
                data = {
                    description: this.form.description,
                    status: status,
                };
            }
            axios
                .put("/v2/clearing/admin/abx/vendor/update/" + this.detailVendor._id, data)
                .then((res) => {
                    if (res.data.iserror == false) {
                        location.reload();
                    }
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.data.err_message);
                    this.isLoadingStatus = false;
                });
        },
        hideModal(modal) {
            this.$refs[modal].hide();
        },
        getData(value) {
            let offset = (value - 1) * this.perPage;
            axios.get("/v2/clearing/admin/abx/vendor/list?&limit=10&status=&offset=" + offset).then((res) => {
                this.vendorDatas = res.data.data.vendor;
                this.lengthData = res.data.data.total;
            });
        },

        Download() {
            // var mywindow = window.open("", "PRINT", "height=400,width=600");

            // mywindow.document.write("<html><head><title>" + document.title + "</title>");
            // mywindow.document.write("</head><body >");
            // mywindow.document.write("<h1>" + document.title + "</h1>");
            // mywindow.document.write(document.getElementById("tableDetail").innerHTML);
            // mywindow.document.write("</body></html>");

            // mywindow.document.close(); // necessary for IE >= 10
            // mywindow.focus(); // necessary for IE >= 10*/

            // mywindow.print();
            // mywindow.close();

            var divToPrint = document.getElementById("tableDetail");
            var htmlToPrint = "" + '<style type="text/css">' + "table th, table td {" + "border:1px solid #000;" + "padding:0.5em;" + "}" + "</style>";
            htmlToPrint += divToPrint.outerHTML;
            var newWin = window.open("");
            newWin.document.write(htmlToPrint);
            newWin.print();
            newWin.close();
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

/* .wrap-button{
  dispa
} */

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
}

.detail-visitorS {
    display: flex;
    gap: 0.5rem;
}

.wrap-detail {
    display: flex;
    justify-content: space-between;
    padding: 0 3rem;
}

.content-left,
.content-right {
    width: 100%;
}

.content-right img {
    width: 100%;
}

.detail-visitorS label {
    width: 8rem;
}

.detail-visitorS span:last-child {
    font-weight: 600;
}

.btn-preview {
    color: var(--clr-scondary);
    cursor: pointer;
}

.form-group label {
    display: block;
    font-weight: 600;
}

.form-group select,
.form-group textarea,
.form-group input {
    font-size: 13px;
    width: 100%;
    border-radius: 5px;
    border: none;
    padding: 0.35rem 0.5rem;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 15%);
}

.form-group textarea {
    resize: none;
    height: 7rem;
}

.form-group select:focus,
.form-group textarea:focus {
    border: initial;
    border-color: var(--clr-primary);
    outline: 0;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 15%);
}

.btn-primer {
    background: var(--clr-scondary);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-primer:hover {
    background-color: var(--clr-scondary-hover);
}

@media print {
    * {
        display: none;
    }
    table {
        display: block;
    }
}
</style>
